<template>
  <v-card>
    <Cabecera 
      v-if="!incrustado && !simplificada" 
      tipoModuloActual="documentacion"
      :incrustado="incrustado"/>
    <StepperPortal v-if="!incrustado && !simplificada" tipoModuloActual="documentacion" />
    <v-container fluid>
      <o-big-title v-if="incrustado">{{titulo}}</o-big-title>
      <o-base-justify-text id="texto-top">
        <span v-html="getTexto('documentacion.explicacion', promocion.codigo)"/>
        <!-- {{$t('reservas.documentacion.docTexto', {modulo: tengoModuloValidarPendiente ? $t('reservas.documentacion.docTextoModulo') : ''})}} -->
      </o-base-justify-text>
      <o-base-justify-text v-if="incrustado">
        {{$t('reservas.documentacion.noTenerDocumentos')}}
      </o-base-justify-text>
      <div class="mb-3" v-if="firmando && !firmaTerminada">
        <div class="signaturit-div">
          <iframe class="signaturit-iframe" :src="reserva.contratoKyc.url"/>
        </div>
      </div>
      <o-main-progress class="elevation-0" :texto="$t('reservas.documentacion.comprobandoFirma')" v-else-if="!loadedAll || (firmando && firmaTerminada)"/>
      <div v-else>
        <!-- <v-layout mb-3>
          <v-flex xs12>
            <o-base-justify-text>{{$t('reservas.documentacion.clientAccept')}}</o-base-justify-text>
          </v-flex>
        </v-layout> -->
        <!-- Resultado de validación -->
        <v-layout v-if="!documentacionVer && getTitular && getTitular.validacionDocumentacion" column>
          <o-medium-title>{{$t('reservas.documentacion.validacion')}}</o-medium-title>
          <o-base-justify-text>
            {{$t('reservas.documentacion.rechazado')}}
          </o-base-justify-text>
          <o-base-justify-text colorClass="error--text">
            {{$t('reservas.documentacion.comentario')}}
          </o-base-justify-text>
          <o-base-justify-text style="white-space: pre-line" colorClass="error--text">{{
            getTitular.validacionDocumentacion.textoValidacion
          }}</o-base-justify-text>
        </v-layout>
        <BaseDocumentacion 
          ref="baseDocumentacion"
          :guardando="waitingForLoad"
          :compradores.sync="compradores"
          @cambiado="$emit('cambiado', $event)"
        />
        <!-- Botonera -->
        <v-layout justify-space-between align-center>
          <v-flex xs2>
            <v-btn
              flat
              class="titleColor--text ml-0 pl-0"
              :disabled="waitingForLoad"
              @click="$router.push({
                name: 'reservas.id',
                params: {id: reserva.id}
              })"
              v-if="!incrustado && !simplificada"
              :icon="$vuetify.breakpoint.xsOnly"
            >
              <!-- eslint-disable-next-line -->
              <v-icon class="mr-1">{{$vuetify.breakpoint.xsOnly ? 'arrow_back':'chevron_left'}}</v-icon>
              <span class="hidden-xs-only">{{$t('reservas.documentacion.volver')}}</span>
            </v-btn>
          </v-flex>
          <v-layout
            v-if="!documentacionVer"
            :column="$vuetify.breakpoint.smAndDown" 
            :shrink="$vuetify.breakpoint.smAndDown" 
            justify-space-around
          >
            <v-btn
              v-if="!incrustado && !simplificada" 
              large
              color="primary"
              :disabled="waitingForLoad"
              :loading="waitingForLoad"
              @click="aceptar(false)"
            >
              {{$t('reservas.documentacion.continuarMasTarde')}}
            </v-btn>
            <v-btn
              large
              color="primary"
              :disabled="waitingForLoad || cargandoExterior"
              :loading="waitingForLoad || cargandoExterior"
              @click="aceptar(true)"
            >
              {{simplificada ? $t('general.misc.guardar') : incrustado ? $t('reservas.documentacion.continuar') : $t('reservas.documentacion.aceptar')}}
            </v-btn>
          </v-layout>
          <v-flex xs2/>
        </v-layout>      
      </div>
      <v-fade-transition>
        <custom-dialog v-if="mostrarErrorFirma" v-model="mostrarErrorFirma" :noCerrar="true">
          <DocumentacionErrorContrato 
            :cargandoExterior="cargandoExterior"
            :incrustado="incrustado"
            @continuar="cerrarPopUpErrorContrato"
          />
        </custom-dialog>
      </v-fade-transition>
      <v-fade-transition>
        <custom-dialog v-if="mostrarComprobarEmail" v-model="mostrarComprobarEmail">
          <ComprobarEmailTelefono
            :compradores="compradores"
            :cargandoExterior="cargandoExterior"
            :saving="waitingForLoadEmail"
            @aceptar="cambiarEmailTelefono"
          />
        </custom-dialog>
      </v-fade-transition>
    </v-container>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseDocumentacion from './BaseDocumentacion'
import DocumentacionErrorContrato from './DocumentacionErrorContrato'
import ComprobarEmailTelefono from '@/components/reservas/comprador/ComprobarEmailTelefono'
import MixinComprador from '@/mixins/comprador'
import MixinDocumentacion from '@/mixins/documentacion'
import MixinEstadoDocumentacion from '@/mixins/estadosReserva/estadoDocumentacion'
import MixinEstadoValidacionDocumentacion from '@/mixins/estadosReserva/estadoValidacionDocumentacion'
import rules from '@/mixins/rules'
import Cabecera from '@/components/Cabecera'
import StepperPortal from '@/components/StepperPortal'

export default {
  mixins: [rules, MixinComprador, MixinDocumentacion, MixinEstadoDocumentacion, MixinEstadoValidacionDocumentacion],
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    },
    simplificada: {
      type: Boolean,
      default: false
    },
    actual: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      compradoresCreated: false,
      waitingForLoad: false,
      loadedAll: false,
      compradores: [],
      mostrarErrorFirma: false,
      firmando: false,
      firmaTerminada: false,
      numeroFirmas: 0,
      mostrarComprobarEmail: false,
      waitingForLoadEmail: false
    }
  },
  components: {
    BaseDocumentacion,
    DocumentacionErrorContrato,
    Cabecera,
    StepperPortal,
    ComprobarEmailTelefono
  },
  async created () {
    this.loadedAll = false
    if (!this.simplificada) {
      window.addEventListener('message', this.completedEvent)
    }
    
    this.compradores = this.getCompradores.map(x => {
      let retorno = {...x}
      retorno.documentacion = []
      // Insertar documentos que faltan con null
      this.carpetas.forEach(carpeta => {
        let documentos = x.documentacion.filter(d => d.carpetaId === carpeta.id)
        retorno.documentacion.push({
          carpetaId: carpeta.id,
          tipoObjetoId: carpeta.tipoObjetoId,
          objetoId: retorno.id,
          carpeta: carpeta,
          documento: documentos.map(doc => {
            return {
              extension: doc.documento.extension,
              id: doc.documento.id,
              mime: doc.documento.mime,
              nombre: doc.documento.nombre,
              descripcionDocumento: doc.descripcionDocumento ? doc.descripcionDocumento : '',
              validado: doc.validado
            }
          }),
          validado: this.estadoValidacionDocumento(documentos, true, carpeta)
        })
      })
      retorno.documentacion = this.documentacionFiltrada(retorno)
      return retorno
    })
    // Si solo queda firmar el contrato
    try {
      if (this.reserva.estadoDocumentacion.codigoEstadoDocumentacion === 3) {
        if (this.reserva.contratoKyc.estado.codigo === 10) {
          // Si ya se firmo llamar a terminar y poner alert
          await this.firmarContratoKyc({id: this.reserva.id, simplificada: false})
          this.addAlert({texto: this.$t('reservas.documentacion.documentoFirmado'), color: 'success'})
          this.$emit('terminado', true)
        } else if (this.reserva.contratoKyc.estado.codigo === 1 || this.reserva.contratoKyc.estado.codigo === 5) {
          this.numeroFirmas = this.reserva.contratoKyc.firmantes.filter(f => f.estado.codigo === 10).length
          this.firmando = true
        } else if (this.reserva.contratoKyc.estado.codigo === 90) {
          this.addAlert({texto: this.$t('reservas.documentacion.firmaRechazada'), color: 'error'})
          this.$emit('error')
        } else { // Anulado o similar
          this.addAlert({texto: this.$t('reservas.documentacion.huboError'), color: 'error'})
          this.$emit('error')
        }
      }
      this.loadedAll = true
    } catch (error) {
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
      this.$emit('error')
    }
    this.$nextTick(() => {
      this.compradoresCreated = true
    })
  },
  computed: {
    ...mapGetters({
      promocion: 'promociones/getActual',
      reserva: 'reservas/_id/getActual',
      getCompradores: 'compradores/getAll',
      autoSave: 'documentacion/getAutoSave',
      modulos: 'modulosOrdenes/modulos/getAll',
      usuario: 'login/usuario',
      carpetas: 'carpetas/getAll',
      getGenerarContratoKyc: 'modulosOrdenes/getGenerarContratoKyc'
    }),
    titulo () {
      return this.getTexto('modulos.documentacion' + (this.reserva.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))
    },
    tengoModuloValidarPendiente () {
      return this.modulos.find(x => x.tipo === 'validacionDocumentacion') != null || this.modulos.find(x => x.tipo === 'pbc') != null
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      modificarEmailsTelefonos: 'compradores/modificarEmailsTelefonos',
      insertarDocumentoComprador: 'documentacion/insertarDocumentoComprador',
      eliminarDocumentosRollback: 'documentacion/eliminarDocumentosRollback',
      modificarDocumentacion: 'documentacion/modificarDocumentacion',
      validarDocumentacion: 'documentacion/validarDocumentacion',
      firmarContratoKyc: 'documentacion/firmarContratoKyc',
      setAutoSave: 'documentacion/setAutoSave',
    }),
    cerrarPopUpErrorContrato () {
      if (this.incrustado) {
        this.terminar(false)
      } else {
        this.$emit('error')
      }
    },
    async cambiarEmailTelefono (compradores) {
      try {
        this.waitingForLoadEmail = true
        await this.modificarEmailsTelefonos({
            id: this.reserva.id,
            compradores
        })
        this.mostrarComprobarEmail = false
        this.aceptar(true, true)
      } catch (error) {
        console.error(error)
        this.waitingForLoadEmail = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    async aceptar (completado = false, comprobado = false) {
      if (completado) {
        let error = false
        for (let i = 0; i < this.compradores.length; i++) {
          let docuValida = this.$refs.baseDocumentacion.documentosSonValidos(i)
          error = error || !docuValida
        }
        if (error && !this.simplificada) {
          this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
          return
        }
        if (!comprobado && this.getGenerarContratoKyc && !this.simplificada) {
          this.mostrarComprobarEmail = true
          return
        }
      }
      // En este array se irán guardando los documentos que se inserten con éxito en la BD
      let documentosInsertados = []
      try {
        this.waitingForLoad = true
        let compradoresParaApi = this.compradores.map(x => this.formatearCompradorParaApi(x))
        // Recorrer la documentación e ir actualizando la id de los documentos que se guarden
        for (var i = 0; i < compradoresParaApi.length; i++) {
          for (var j = 0; j < compradoresParaApi[i].documentacion.length; j++) {
            if (compradoresParaApi[i].documentacion[j].id == null) {
              const documentoInsertado = await this.insertarDocumentoComprador({
                id: this.reserva.id,
                compradorId: compradoresParaApi[i].id,
                documento: compradoresParaApi[i].documentacion[j]
              })
              compradoresParaApi[i].documentacion[j] = {
                id: documentoInsertado.documentoId
              }
              documentosInsertados.push(documentoInsertado)
            }
          }
        }
        await this.modificarDocumentacion({
          id: this.reserva.id,
          compradores: compradoresParaApi,
          completado: completado,
          simplificada: this.simplificada
        })
      } catch (error) {
        await this.eliminarDocumentosRollback({
          documentos: documentosInsertados.map(x => {
            return x.documentoId
          })
        })
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
        this.waitingForLoad = false
        return
      }
      try {
        if (!this.simplificada && completado && this.reserva.estadoDocumentacion.codigoEstadoDocumentacion === 3) { // Si tengo que firmar el KYC
          this.firmando = true
          await this.$nextTick()
          this.$vuetify.goTo('#texto-top')
        } else {
          this.terminar(completado)
        }
        if (!this.incrustado) {
          this.addAlert({texto: this.$t('general.misc.datosGuardadosExito'), color: 'success'})
        }
        this.waitingForLoad = false
        return true
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
        this.waitingForLoad = false
      }
    },
    terminar (terminar = true) {
      this.$emit('cambiado', false)
      this.$emit('terminado', terminar)
    },
    async completedEvent (e) {
      try {
        if (e.data.event === 'completed' && this.actual) {
          this.numeroFirmas = this.reserva.contratoKyc.firmantes.length
          if (this.numeroFirmas === this.reserva.contratoKyc.firmantes.length) {
            this.firmaTerminada = true
            await this.firmarContratoKyc({id: this.reserva.id, simplificada: false})
            this.terminar(true)
          }
        }
      } catch (error) {
        console.log(error)
        if (error.code && Number(error.code) === 16) { // PETO LA FIRMA
          this.mostrarErrorFirma = true
        } else {
          this.addAlert({texto: error.message, color: 'error'})
          this.$emit('error')
        }
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.completedEvent)
  },
  watch: {
    compradores: {
      deep: true,
      handler () {
        this.$emit('cambiado', this.compradoresCreated)
      }
    },
    async autoSave (newValue) {
      console.log('cambio auto guardo')
      if (newValue) {
        console.log("auto guardo")
        this.aceptar(true)
        this.setAutoSave(false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/documentacion/Documentacion.vue